import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import { LOGS_KEY } from '../../utils/constants';
import { logger } from '../../shared/logger';

class ErrorBoundary extends React.Component {
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        const { onError, children, ...rest } = this.props;

        isFunction(onError) && onError(error);

        logger.error(error, {
            [LOGS_KEY]: 'Personalized component render failed',
            info,
            componentProps: JSON.stringify(rest),
        });
    }

    render() {
        if (this.state.hasError) {
            return <div className="personalized-content-error" />;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    onError: PropTypes.func,
};

export default ErrorBoundary;
